import { isFunction } from 'lodash';
import { bool, func, string } from 'prop-types';
import { Component } from 'react';

import { Spinner } from '@alkem/react-ui-spinner';

import './submit-button.scss';

class AuthFormSubmit extends Component<{
  id?: string;
  label?: string;
  action?: string;
  onSubmit?: Function;
  disabled?: boolean;
  loading?: boolean;
  withForm?: boolean;
}> {
  static propTypes = {
    id: string,
    label: string,
    action: string,
    onSubmit: func,
    disabled: bool,
    loading: bool,
    withForm: bool,
  };

  onSubmit = (event) => {
    event.preventDefault();
    const { disabled, onSubmit } = this.props;
    if (!disabled && isFunction(onSubmit)) {
      onSubmit(event);
    }
    return false;
  };

  renderButton() {
    const { id, label, disabled, loading } = this.props;
    return (
      <button
        id={id}
        className="AuthFormSubmit__button Button btn btn-primary alk-flex"
        type="submit"
        disabled={disabled}
      >
        {label}
        {loading && <Spinner small />}
      </button>
    );
  }

  render() {
    const { action, withForm } = this.props;
    if (withForm) {
      return (
        <form
          className="AuthFormSubmit"
          action={action}
          onSubmit={this.onSubmit}
        >
          {this.renderButton()}
        </form>
      );
    }
    return <div className="AuthFormSubmit">{this.renderButton()}</div>;
  }
}

export default AuthFormSubmit;
